// extracted by mini-css-extract-plugin
export default {"page":"trevolt_page__7Wgyt","pageContent":"trevolt_pageContent__GF029","logoSpan":"trevolt_logoSpan__jam5s","mainDiv":"trevolt_mainDiv__ppjxA","splitDiv":"trevolt_splitDiv__WKflC"};